import {useEffect, useState} from "react";
import $ from "jquery";
import style from "./Calendar.module.css"
import Formatter from "../../utils/Formatter";

window.$ = $;

function Calendar(props) {

    const [className, setClassName] = useState("")

    useEffect(() => {
        prepareCalendar()
    },[props.rerender])

    useEffect(() => {
        if (props.errorClause) {
            setClassName(style.errorBorder)
        } else if (props.disabled) {
            setClassName(style.inputDataDisabled)
        } else {
            setClassName(style.inputData)
        }
        disabledCalendar()
    }, [props.errorClause, props.disabled])

    function prepareCalendar() {
        $(document).ready(function () {
            $('#' + props.id).datepicker({
                inputFormat: ["dd/MM/yyyy"],
                outputFormat: "dd/MM/yyyy"
            }).on("change", function (event) {
                if (props.onChange) {
                    return props.onChange(event.target.id, event.target.value, props.index, props.nomeOggetto)
                }
            });
        });
    }

    function disabledCalendar() {
        if (props.disabled) {
            $(document).ready(function () {
                $("#" + props.id).datepicker("disable");
            });
        } else {
            $(document).ready(function () {
                $("#" + props.id).datepicker("enable");
            });
        }
    }

    function updateCaret(event) {
        const caret = event.target.selectionStart
        let element = event.target
        let updateCaret = event.target.value.length
        if (props.value.length - event.target.value.length !== 1) {
            event.target.value =
                Formatter.formatDate(event.target.value, "dd/MM/yyyy")
        }
        updateCaret = event.target.value.length - updateCaret
        window.requestAnimationFrame(() => {
            element.selectionStart = caret + updateCaret
            element.selectionEnd = caret + updateCaret
        })
    }

    return (
        <div className={"it-datepicker-wrapper"}>
            <div className={"form-group ".concat(className)} style={{marginBottom: "0", minWidth: "180px"}}>
                <input className={"form-control it-date-datepicker"}
                       id={props.id ? props.id : "date1"}
                       type="text"
                       value={props.value}
                       onChange={(event) => {
                           updateCaret(event)
                           props.onChange(event.target.id, event.target.value, props.index, props.nomeOggetto)
                       }}
                       disabled={props.disabled}
                       placeholder="gg/mm/aaaa">
                </input>
                <label htmlFor={props.id ? props.id : "date1"}/>
            </div>
            <div>
                {props.errorClause ?
                    <label className={style.errorMessage} htmlFor={props.id}>{props.errorMessage}</label> : null}
            </div>
        </div>
    )


}

export default Calendar